(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["primordial-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('primordial-product-details')) {
  customElements.define('primordial-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const trigger = event.target.closest('[data-drawer]');
        if (trigger && this.contains(trigger)) {
          const dialog = document.getElementById(trigger.dataset.drawer);
          if (dialog && !dialog.open) this.openDrawer(dialog, trigger);
          return;
        }
        const close = event.target.closest('[data-drawer-close]');
        if (close) {
          close.closest('dialog')?.close();
          return;
        }
        if (event.target.closest('[data-size-guide-contact]')) {
          this.querySelector('dialog[open]')?.close();
          return;
        }
        if (event.target instanceof HTMLDialogElement) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => {
          this.restoreScroll();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
      });
    }
    openDrawer(dialog, trigger) {
      this.opener = trigger;
      const body = document.body;
      const root = document.documentElement;
      const properties = ['position', 'top', 'left', 'width', 'overflow', 'paddingRight', 'boxSizing'];
      this.bodyLock = {
        x: window.scrollX,
        y: window.scrollY,
        rootOverflow: root.style.overflow,
        styles: Object.fromEntries(properties.map(key => [key, body.style[key]]))
      };
      const scrollbar = Math.max(0, window.innerWidth - root.clientWidth);
      const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
      body.style.position = 'fixed';
      body.style.top = `${-this.bodyLock.y}px`;
      body.style.left = '0';
      body.style.width = '100%';
      body.style.boxSizing = 'border-box';
      body.style.overflow = 'hidden';
      if (scrollbar) body.style.paddingRight = `${padding + scrollbar}px`;
      root.style.overflow = 'hidden';
      try {
        dialog.showModal();
        dialog.querySelector('[data-drawer-close]')?.focus({ preventScroll: true });
      } catch (error) {
        this.restoreScroll();
        throw error;
      }
    }
    restoreScroll() {
      if (!this.bodyLock) return;
      const state = this.bodyLock;
      this.bodyLock = null;
      Object.entries(state.styles).forEach(([key, value]) => { document.body.style[key] = value; });
      const root = document.documentElement;
      root.style.overflow = state.rootOverflow;
      const behavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(state.x, state.y);
      root.style.scrollBehavior = behavior;
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this.restoreScroll();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
